var render = function render(_c,_vm){return _c('fieldset',{staticClass:"relative w-full border-b mb-2 pb-2 xl:mb-4 xl:pb-4 min-w-full"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }